module.exports = __webpack_public_path__ + "7892c9cbf5ccc849b5a8397a937c96bc.png";